import { Component, Input, OnInit, Output, EventEmitter, Inject } from '@angular/core';
// import { FormBuilder, FormGroup,FormArray } from '@angular/forms';

import { FormArray, FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { CUSTOMER_ENTITY_SERVICE_TOKEN, REQUISITION_ENTITY_SERVICE_TOKEN } from '../../../../injection-tokens/entity-service-tokens';
import { IRequisitionEntityService } from '../../../../interfaces/entities/requisition-entity-service-interface';
import { NotificationService } from '../../../../services/notification.service';
import { Requisition } from '../../../../models/entities/requisition-model';
import { RequisitionData } from '../../../../models/wizard-plugin-models/requisition-data';
import { CustomerEntity } from '../../../../models/entities/customer';
import { CourseEntity } from '../../../../models/entities/course';
import { TrainerEntity } from '../../../../models/entities/trainer';
// import { ResourceTemplate } from '../../../../models/update-requisition-model';
import { BillingDetailsData } from '../../../../models/wizard-plugin-models/billing-details-data';
import { AdditionalInformationData } from '../../../../models/wizard-plugin-models/additional-information-data';
import { Log, IShortLogger } from '../../../../services/logger.service';
import { ICustomerEntityService } from '../../../../interfaces/entities/customer-entity-service.interface';
import { ErrorHandlerService } from '../../../../decoration-base/error-handler.service';


interface TrainingSchedule {
  Id: string;
  Title: string;
  DateRanges: DateRange[];
  Participants: string[];
  Trainers: Trainer[];
  Course?: Course;
  ResourceType?: string;
  ResourceDetails?: any;
  RemovalOption: 'immediate' | 'scheduled' | 'manual' | 'None';
  RemovalDateTime?: Date;
  TrainersRemarks?: string;
  TrainingDetail?: string;
  ResourceTemplateIds?: ResourceTemplate[];
  AccessViaInvitedEmailOnly:Boolean ;
}


interface DateRange {
  Id?: string;
  Title: string;
  StartDate: Date;
  EndDate: Date;
  StartTime: string;
  EndTime: string;
}

interface Course {
  Id: string;
  Name: string;
  Code: string;
  Provider: string;
  description?: string;
  duration?: string;
  vmImage?: any;
  labs?: any[];
  showMenu?: boolean;
  isActive?: boolean;
  createdBy?: string;
  createdOn?: string;
  updatedOn?: string;
  updatedBy?: string;
  entityType?: string;
}

interface Trainer {
  Id: string;
  Name: string;
}

interface ResourceTemplate {
  id: string;
  name: string;
}

interface ResourceType {
  value: string;
  label: string;
}



@Component({
  selector: 'app-requisition-preview',
  templateUrl: './requisition-preview-view.component.html',
  styleUrl: './requisition-preview-view.component.css'
})
export class RequisitionPreviewViewComponent implements OnInit {
  private readonly logger: IShortLogger<RequisitionPreviewViewComponent> = Log.create(RequisitionPreviewViewComponent);

  public requisitionForm!: FormGroup;

  public requisitionData: RequisitionData | null = null;
  public billingDetailsData:BillingDetailsData | null = null;
  public trainingSchedulesData:TrainingSchedule[] = [];
  public additionalInformationData:AdditionalInformationData | null = null;
  // @Input() requisitionData: RequisitionData | null = null;
  @Input() customers: CustomerEntity[] = [];
  @Input() courses: CourseEntity[] = [];
  @Input() trainers: TrainerEntity[] = [];
  @Input() resourceTemplatesByType: { [key: string]: ResourceTemplate[] } = {};

  @Output() statusUpdate = new EventEmitter<void>();
  @Output() cancel = new EventEmitter<void>();

  activeTabIndex = 0;

  public showHide: string = ""; // This will be set based on the route parameter
  public requisitionId: string = '';
  public requisition: Requisition = new Requisition();
  constructor(private formBuilder: FormBuilder,
    @Inject(REQUISITION_ENTITY_SERVICE_TOKEN) public requisitionService: IRequisitionEntityService,
    @Inject(CUSTOMER_ENTITY_SERVICE_TOKEN) private customerService: ICustomerEntityService,
    private errorHandler: ErrorHandlerService,
    private route: ActivatedRoute,
    private notification: NotificationService) { }

  ngOnInit(): void {
    this.requisitionForm = this.formBuilder.group({
      schedules: this.formBuilder.array([])
    });
    // Load data first, then initialize form
    this.route.paramMap.subscribe(params => {
      this.requisitionId = params.get('requisitionId') || '';
      this.showHide = params.get('showHide') ||"";
    });
   
    if (this.requisitionId) {
      this.loadRequisitionData();
    }

    

    // Initialize the form here where FormBuilder is guaranteed to be available
    this.createForm();


    this.requisitionForm.patchValue({
      requisition: {
        // docDate: this.formatDate(today),
        docNo: `REQ-${Math.floor(1000 + Math.random() * 9000)}`,
        status: 'Draft'
      }
    });
  }

 

  private loadRequisitionData(): void {
    this.requisitionService.getRequisitionById(this.requisitionId).subscribe((res: any) => {
      this.requisitionData = res.data.RequisitionData;
      this.billingDetailsData = res.data.BillingDetailsData;
      this.trainingSchedulesData = res.data.TrainingSchedulesData;
      this.additionalInformationData = res.data.AdditionalInformationData;

      this.logger.i("training schedule data :: res.data.TrainingSchedulesData", res.data.TrainingSchedulesData);
      this.logger.i("requisition data :: ", this.requisitionData);
      this.logger.i("billing details data :: ", this.billingDetailsData);
      this.logger.i("additional information data :: ", this.additionalInformationData);
      // this.initializeForm();
    });
  }


  private createForm() {
    this.requisitionForm = this.formBuilder.group({
      requisition: this.formBuilder.group({
        docNo: ['', Validators.required],
        docDate: ['', Validators.required],
        status: ['Draft', Validators.required]
      }),
      customerDetails: this.formBuilder.group({
        customer: ['', Validators.required],
        customerType: ['Corporate', Validators.required],
        contactPerson: ['', Validators.required],
        contactNo: ['', Validators.required],
        emailId: ['', [Validators.required, Validators.email]]
      }),
      billingDetails: this.formBuilder.group({
        billingAddress: ['', Validators.required],
        gstNo: [''],
        paymentTerms: ['Advance Payment', Validators.required],
        estimateAmount: ['', [Validators.required, Validators.min(0)]]
      }),
      trainingSchedules: this.formBuilder.array([this.createScheduleGroup()]),
      additionalInfo: this.formBuilder.group({
        specialRequirements: [''],
        finalComments: [''],
      })
    });
  }

  private createScheduleGroup(): FormGroup {
    return this.formBuilder.group({
      title: ['', Validators.required],
      startDate: ['', Validators.required],
      endDate: ['', Validators.required],
      startTime: ['', Validators.required],
      endTime: ['', Validators.required],
      offDates: [''],
      participants: [''],
      trainers: [''],
      resourceType: [''], // This field stores the selected resource type
      resourceTemplate: [''],
      courseId: ['', Validators.required],
      deletionType: ['None'],
      deletionDate: [''],
      deletionTime: [''],
      // Dynamic resource controls will be added here
      vmControls: this.formBuilder.group({}), // For VM specific controls
      cloudDbControls: this.formBuilder.group({}), // For CloudDB specific controls
      appServiceControls: this.formBuilder.group({}), // For AppService specific controls
      userAccountControls: this.formBuilder.group({}), // For UserAccount specific controls
      _resourceValues: this.formBuilder.control({}) // Hidden control to store resource values
    });
  }

  setActiveTab(index: number): void {
    this.activeTabIndex = index;
  }

  toggleSection(section: HTMLElement): void {
    const content = section.querySelector('.section-content') as HTMLElement;
    const title = section.querySelector('.section-title') as HTMLElement;

    if (content) {
      if (content.style.display === 'none') {
        content.style.display = 'block';
        title?.classList.remove('collapsed');
      } else {
        content.style.display = 'none';
        title?.classList.add('collapsed');
      }
    }
  }

  getCustomerName(customerId: string): string {
    const customer = this.customers.find(c => c.id === customerId);
    return customer?.name || 'Unknown Customer';
  }

  getCourseName(courseId: string): string {
    const course = this.courses.find(c => c.id === courseId);
    return course?.name || 'Unknown Course';
  }

  getTrainerName(trainerId: string): string {
    const trainer = this.trainers.find(t => t.id === trainerId);
    return trainer?.name || 'Unknown Trainer';
  }

  getResourceTypeLabel(resourceType: string): string {
    const labels: { [key: string]: string } = {
      'vm': 'Virtual Machine',
      'db': 'Cloud Database',
      'app': 'App Service',
      'acc': 'User Account'
    };
    return labels[resourceType] || resourceType;
  }

  getResourceTemplateName(type: string, templateId: string): string {
    const templates = this.resourceTemplatesByType[type] || [];
    // const template = templates.find(t => t.id === templateId);
    return ""//template?.name || 'Unknown Template';
  }

  updateRequistionStatus(): void {
    const objRequisition: any
      = {
      requisitionId: this.requisitionId,
      status: 'Approve' // or any other status you want to set
    };
    this.requisitionService.updateRequisitionStatus(objRequisition).subscribe((res: any) => {
      this.notification.notify("Successfully Approved", "success", 3000);
    });
  }

  cancelRequisition(): void {
    this.cancel.emit();
  }
  log(value: any): void {
  this.logger.i('Logged value:', value);
}

  formatTime(time: string): string {
    return time || '';
  }


  formatDateRange(startDate: Date, endDate: Date): string {
    if (!startDate || !endDate) return '';

    const start = new Date(startDate);
    const end = new Date(endDate);

    if (this.isSameDate(start, end)) {
      return this.formatDate(start);
    }
    return `${this.formatDate(start)} - ${this.formatDate(end)}`;
  }

  private isSameDate(date1: Date, date2: Date): boolean {
    if (!date1 || !date2) return false;
    return date1.toDateString() === date2.toDateString();
  }

  formatDate(date: Date): string {
    if (!date) return '';
    return new Date(date).toLocaleDateString('en-US', {
      weekday: 'short',
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  }


  getTotalParticipants(participants: string[]): number {
    return participants ? participants.length : 0;
  }

  getDisplayParticipants(participants: string[], maxDisplay: number = 3): string[] {
    return participants ? participants.slice(0, maxDisplay) : [];
  }

  getRemainingParticipantsCount(participants: string[], maxDisplay: number = 3): number {
    if (!participants) return 0;
    return Math.max(0, participants.length - maxDisplay);
  }

  getTrainerNames(trainers: Trainer[]): string[] {
    return trainers ? trainers.map(trainer => trainer.Name) : [];
  }

}
